import io from 'socket.io-client';
// export const NOTIFICATION_SERVER_URL = 'http://192.168.1.8:3009';
export const NOTIFICATION_SERVER_URL = process.env.REACT_APP_NOTIFICATION_SERVER_URL ?? 'https://noti.nagaco.com';
export const socket = io(NOTIFICATION_SERVER_URL, {
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 1000,
    extraHeaders: {
        Authorization: `${localStorage.getItem('auth_token') || 'Bearer'}`,
    },
    auth: { authorization: `${localStorage.getItem('auth_token') || 'Bearer'}` },
});
